<div>
  <mat-form-field appearance="outline" [dir]="'dir' | translate">
    <mat-label>{{ "SEARCH" | translate }}</mat-label>
    <input type="text" [disabled]="disabled" matInput #searchInput />
    <mat-icon matSuffix>search</mat-icon>
  </mat-form-field>
</div>
